var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhitecircleplus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_296_6045)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_296_6045",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.75C10.9519 13.75 13.75 10.9519 13.75 7.5C13.75 4.04813 10.9519 1.25 7.5 1.25C4.04813 1.25 1.25 4.04813 1.25 7.5C1.25 10.9519 4.04813 13.75 7.5 13.75Z",
    fill: "white",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5V10M5 7.5H10",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_296_6045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H15V15H0V0Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_296_6045"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitecircleplus);
export default __webpack_public_path__ + "static/media/white circle plus.daa89e5a45b9100e49ee4dc56fe80dc4.svg";
export { ForwardRef as ReactComponent };